import { render, staticRenderFns } from "./aqxj_pz.vue?vue&type=template&id=16a28d58&scoped=true"
import script from "./aqxj_pz.vue?vue&type=script&lang=js"
export * from "./aqxj_pz.vue?vue&type=script&lang=js"
import style0 from "./aqxj_pz.vue?vue&type=style&index=0&id=16a28d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a28d58",
  null
  
)

export default component.exports